import React from 'react';
import PropTypes from 'prop-types';
import QuoteView from '../quoteView';
import { formatPrice } from '../../../quotes/priceFormatter';
import classNames from 'classnames';
import {
  getMsrpColumnClassNames,
  getDNetColumnClassNames,
} from '../../../quotes/quotePriceMode';
import { isNumber } from 'lodash';
import Price from '../../../price';
import { appConfig } from '@ami/react/core';
import { PriceBanner } from '../../PricingAndLeadTimesBanner';

function priceToText(price, isNegative) {
  if (!isNumber(price)) return price;

  return formatPrice(price * (isNegative ? -1 : 1));
}

const Freight = ({ quote, msrpClassNames, dNetClassNames }) => {
  const { freightSurcharge } = quote.priceInformation;

  return (
    <React.Fragment>
      <Price
        label="Freight"
        valueDNet={quote.priceInformation.freightSurcharge}
        valueMsrp={quote.msrpInformation.freightSurcharge}
        hide={freightSurcharge === 0}
        msrpClassNames={msrpClassNames}
        dNetClassNames={dNetClassNames}
      />
      <Price
        label="Freight"
        valueDNet="INCLUDED"
        valueMsrp="INCLUDED"
        hide={freightSurcharge > 0}
        msrpClassNames={msrpClassNames}
        dNetClassNames={dNetClassNames}
      />
    </React.Fragment>
  );
};

const Header = ({ msrpClassNames, dNetClassNames }) => (
  <div className="row justify-content-end">
    <div className="col-6 quote-price-label" />
    <h5 className={classNames('quote-price-value', msrpClassNames)}>MSRP</h5>
    <h5 className={classNames('quote-price-value', dNetClassNames)}>D. NET</h5>
  </div>
);

export default class QuotePricingComponent extends React.PureComponent {
  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    selectedPriceMode: PropTypes.string.isRequired,
  };

  render() {
    const { quote, selectedPriceMode } = this.props;
    const maskPricingAndLeadTimes = quote.maskPricingAndLeadTimes;
    const msrpClassNames = getMsrpColumnClassNames(selectedPriceMode);
    const dNetClassNames = getDNetColumnClassNames(selectedPriceMode);
    return (
      <div className="card mb-3 bg-none flex-fill">
        <div className="card-body px-3 py-0">
          <div className="col">
            <Header
              msrpClassNames={msrpClassNames}
              dNetClassNames={dNetClassNames}
            />
            { !maskPricingAndLeadTimes && 
            <div>
            <Price
              label="Products"
              valueDNet={
                quote.priceInformation.productsSubTotal +
                quote.priceInformation.customLineItemsSubTotal
              }
              valueMsrp={
                quote.msrpInformation.productsSubTotal +
                quote.priceInformation.customLineItemsSubTotal
              }
              msrpClassNames={msrpClassNames}
              dNetClassNames={dNetClassNames}
            />
            <Freight
              quote={quote}
              msrpClassNames={msrpClassNames}
              dNetClassNames={dNetClassNames}
            />
            <Price
              label="Installation"
              valueDNet={quote.priceInformation.installationSubTotal}
              valueMsrp={quote.msrpInformation.installationSubTotal}
              hide={!quote.installationEnabled}
              msrpClassNames={msrpClassNames}
              dNetClassNames={dNetClassNames}
            />
            <Price
              label="Subtotal"
              valueDNet={quote.priceInformation.subTotal}
              valueMsrp={quote.msrpInformation.subTotal}
              msrpClassNames={msrpClassNames}
              dNetClassNames={dNetClassNames}
            />
            {quote.overallDiscounts.map((x, idx) => (
              <Price
                key={idx}
                label={x.name}
                valueDNet={priceToText(x.amount, true)}
                isNegative={true}
                msrpClassNames={msrpClassNames}
                dNetClassNames={dNetClassNames}
              />
            ))}
            {quote.overallDiscounts.length > 0 && (
              <Price
                label="Subtotal After Discount"
                valueDNet={quote.priceInformation.discountedSubTotal}
                valueMsrp={quote.msrpInformation.discountedSubTotal}
                msrpClassNames={msrpClassNames}
                dNetClassNames={dNetClassNames}
              />
            )}
            <Price
              label="Tax"
              valueDNet={quote.priceInformation.tax}
              valueMsrp={quote.msrpInformation.tax}
              msrpClassNames={msrpClassNames}
              dNetClassNames={dNetClassNames}
            />
            </div>
          }
            <Price
              label={`Total (${quote.isoCurrencySymbol})`}
              valueDNet={ maskPricingAndLeadTimes ? "N/A" : quote.priceInformation.total}
              valueMsrp={ maskPricingAndLeadTimes ? "N/A" : quote.msrpInformation.total}
              msrpClassNames={msrpClassNames}
              dNetClassNames={dNetClassNames}
            />
            { maskPricingAndLeadTimes && <PriceBanner />}
          </div>
        </div>
      </div>
    );
  }
}
